import { GoogleAuthService } from './google-auth.service';
import { BrowserModule } from '@angular/platform-browser';


import { AppRoutingModule } from './app-routing.module';

import { SigninComponent } from './signin/signin.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FgpasswordComponent } from './fgpassword/fgpassword.component';
import { CreateclientComponent } from './createclient/createclient.component';
import { CreateuserComponent } from './createuser/createuser.component';
import { CreateadminComponent } from './createadmin/createadmincomponent';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { AuthService } from './services/auth.service';
import { CreatepatientComponent } from './createpatient/createpatient.component';
import { SearchComponent } from './search/search.component';
import { HomeComponent } from './home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSortModule, MatToolbarModule } from '@angular/material';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SearchService } from './services/search.service';
import { UserprofileComponent } from './userprofile/userprofile.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { AllusersComponent } from './allusers/allusers.component';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppComponent } from './app.component';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule
} from 'ng-pick-datetime';
import { MatNativeDateModule } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportService } from './services/report.service';
import { ReportComponent } from './report/report.component';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToppyModule } from 'toppy';
import { ConfirmationDialogComponent } from './components/ui/confirmation-dialog/confirmation-dialog.component';
import { UploadDialogComponent } from './components/ui/uploaddialog/uploaddialog.component';
import { HttpClientModule } from '@angular/common/http';
import { InputFileComponent } from './components/ui/inputfile/inputfile.component';
import { NoteDialogComponent } from './components/ui/note-dialog/note-dialog.component';
import { AllNotesDIalogComponent } from './components/ui/all-notes-dialog/all-notes-dialog.component';
import { ShowStudiesDialogComponent } from './components/ui/show-studies-dialog/show-studies-dialog.component';
import { DragAndDropUploadComponent } from './components/ui/drag-and-drop-upload/drag-and-drop-upload.component';

@NgModule({
  declarations: [

    AppComponent,
    SigninComponent,
    FgpasswordComponent,
    CreateclientComponent,
    CreateuserComponent,
    CreateadminComponent,
    FooterComponent,
    HeaderComponent,
    CreatepatientComponent,
    SearchComponent,
    HomeComponent,
    UserprofileComponent,
    AllusersComponent,
    ReportComponent,
    ConfirmationDialogComponent,
    InputFileComponent,
    UploadDialogComponent,
    NoteDialogComponent,
    AllNotesDIalogComponent,
    ShowStudiesDialogComponent,
    DragAndDropUploadComponent
  ],
  imports: [
    BrowserModule,
    ToppyModule,
    FormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    AppRoutingModule,
    FlexLayoutModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatSnackBarModule,
    MatDividerModule,
    MatProgressBarModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatChipsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatSidenavModule,
    MatDialogModule,
    HttpClientModule,
    MatSortModule
  ],
  providers:
    [
      AuthService,
      GoogleAuthService,
      SearchService,
      ReportService,
      { provide: MatDialogRef, useValue: {} },
      { provide: MAT_DIALOG_DATA, useValue: [] }
    ],
  bootstrap: [AppComponent],
  entryComponents: [
    UserprofileComponent,
    UploadDialogComponent,
    ConfirmationDialogComponent,
    NoteDialogComponent,
    AllNotesDIalogComponent,
    ShowStudiesDialogComponent
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule { }
